import { ApiDeleteRequest } from "../api-delete-request";
import { ApiParameters } from "../api-parameters";

export class CancelTicketOwnershipRequest extends ApiDeleteRequest
{
    public constructor(playerId: number, ticketNumber: number, ticketLetter: string, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
                .addQueryParameter('playerid', playerId)
                .addQueryParameter('ticketNumber', ticketNumber)
                .addQueryParameter('ticketLetter', ticketLetter);
        super(  'subscription/cancelticket',
                parameters, 
                null, 
                null,
                webapiBasepath   
            );
    }
}